import { useState, memo } from "react";
import { LuSendHorizontal } from "react-icons/lu";
import { useConfig } from "../../../contexts/ConfigContext";
import { TextField, Button } from "@mui/material";
import AudioRecorder from "./AudioRecorder";

function ChatInput({ onSubmit, onMessageChange, message }) {
  const { config, configOpen } = useConfig();

  const [inputFocused, setInputFocused] = useState(false);

  const onFocus = () => setInputFocused(true);
  const onBlur = () => setInputFocused(false);

  const enterSubmit = (e) => {
    if (e.charCode === 13) {
      onSubmit(e);
      e.preventDefault();
      return false;
    }
  };

  return (
    <>
      <TextField
        aria-label="Type your message here..."
        placeholder="Type your message here..."
        value={message}
        focused={inputFocused}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyPress={(e) => enterSubmit(e)}
        onChange={(e) => onMessageChange(e.target.value)}
        fullWidth
        autoFocus={!configOpen}
        multiline
        maxRows={6}
        minRows={1}
        sx={{
          "& .MuiOutlinedInput-root": {
            fontSize: 16,
            "&.Mui-focused fieldset": {
              borderColor: config.color.primary,
              borderWidth: 2,
            },
          },
        }}
        InputProps={{
          sx: { borderRadius: 3, p: 0.65, pl: 2 },
          endAdornment:
            message.length > 0 || config.voiceInputOff === true ? (
              <>
                <Button
                  onClick={onSubmit}
                  sx={{
                    minWidth: 45,
                    minHeight: 38,
                    ml: 1,
                    mt: "auto",
                    borderRadius: 30,
                    backgroundColor: config.color.primary,
                    "@media (hover: hover)": {
                      "&:hover": {
                        backgroundColor: config.color.primary,
                        opacity: 0.9,
                      },
                    },
                  }}
                  variant="contained"
                  disabled={!message.length}
                  disableRipple
                >
                  <LuSendHorizontal fontSize={23} />
                </Button>
              </>
            ) : (
              <AudioRecorder onMessageChange={onMessageChange} />
            ),
        }}
      />
    </>
  );
}

export default memo(ChatInput, (prevProps, nextProps) => {
  return prevProps.message === nextProps.message;
});
